(function () {
  if (window.__webinarVwoBound) return;
  window.__webinarVwoBound = true;

  var FORM_ID = 'SpjSWk';
  var OPEN_DELAY_MS = 15000;

  function openKlaviyoForm(formId) {
    formId = formId || FORM_ID;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
      window._klOnsite.openForm([formId]);
    } else {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
          window._klOnsite.openForm([formId]);
          clearInterval(timer);
        } else if (tries > 25) {
          clearInterval(timer);
        }
      }, 200);
    }
  }

  function closePopup() {
    document.querySelectorAll('#webinar-vwo-popup, .webinar-vwo--popup').forEach(function (popup) {
      popup.classList.remove('is-open');
      popup.classList.add('is-closed');
      popup.setAttribute('hidden', '');
      popup.style.setProperty('display', 'none', 'important');
      var section = popup.closest('.shopify-section');
      if (section) section.style.setProperty('display', 'none', 'important');
    });
  }

  function openPopup() {
    var popup = document.getElementById('webinar-vwo-popup');
    if (!popup) return;
    popup.classList.remove('is-closed');
    popup.removeAttribute('hidden');
    popup.classList.add('is-open');
    popup.style.setProperty('display', 'flex', 'important');
  }

  window.inneOpenWebinarForm = function (formId) {
    openKlaviyoForm(formId || FORM_ID);
  };

  window.inneCloseWebinarPopup = function () {
    closePopup();
  };

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('[data-webinar-close], .webinar-vwo__close, .webinar-vwo__dismiss');
    if (closeBtn) {
      event.preventDefault();
      event.stopPropagation();
      window.inneCloseWebinarPopup();
      return;
    }

    var openBtn = event.target.closest('[data-webinar-open-form]');
    if (openBtn) {
      event.preventDefault();
      window.inneOpenWebinarForm(openBtn.getAttribute('data-webinar-open-form') || FORM_ID);
      return;
    }

    if (event.target && event.target.id === 'webinar-vwo-popup') {
      window.inneCloseWebinarPopup();
    }
  }, true);

  var preview = new URLSearchParams(window.location.search).get('webinar_preview');

  function applyStaticPreview() {
    if (preview === 'bar') {
      document.querySelectorAll('.webinar-vwo--bar').forEach(function (el) {
        el.style.display = 'block';
      });
    }
    if (preview === 'home') {
      document.querySelectorAll('.webinar-vwo--homepage').forEach(function (el) {
        el.style.display = 'block';
      });
    }
    if (preview === 'all') {
      document.querySelectorAll('.webinar-vwo--bar, .webinar-vwo--homepage').forEach(function (el) {
        el.style.display = 'block';
      });
    }
  }

  applyStaticPreview();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStaticPreview);
  }

  var shouldAutoOpenPopup = preview === 'popup' || preview === 'all';
  if (shouldAutoOpenPopup) {
    setTimeout(openPopup, OPEN_DELAY_MS);
  }
})();
